
export const PENDING = "_PENDING";
export const FULFILLED = "_FULFILLED";
export const REJECTED = "_REJECTED";


// WEBPACK FOOTER //
// ./src/actions/constants.js